import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusEmptyIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M3.1 6A2.9 2.9 0 1 0 9 6a2.9 2.9 0 0 0-6 0ZM6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default StatusEmptyIcon;
